import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * EL INTERRUPTOR — el `Switch` de shadcn, a mano.
 *
 * 📍 No hay primitivo `.kb-*` de interruptor en `styles.css`, y `styles.css`
 * no es de este módulo; por eso vive acá como componente, con su CSS sobre los
 * tokens (`hsl(var(--x))`). Si otra pantalla lo necesita, el día que se agregue
 * `.kb-switch` al sistema éste se reemplaza por esa clase.
 *
 * 🔴 No guarda nada: avisa con `(cambiar)` y la pantalla decide. Mientras la
 * pantalla guarda, `ocupado` lo deja quieto para que un doble clic no mande dos.
 */
@Component({
  selector: 'app-ia-interruptor',
  templateUrl: './ia-interruptor.component.html',
  styleUrls: ['./ia-interruptor.component.css']
})
export class IaInterruptorComponent {
  @Input() encendido = false;
  @Input() deshabilitado = false;
  @Input() ocupado = false;
  @Input() etiqueta = '';
  @Output() cambiar = new EventEmitter<boolean>();

  tocar = (ev: Event): void => {
    ev.stopPropagation();
    if (this.deshabilitado || this.ocupado) return;
    this.cambiar.emit(!this.encendido);
  };
}
